/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa-theme
 * @link https://github.com/scandipwa/scandipwa-theme
 */

import { Field, Mutation } from '@tilework/opus';

import { CheckoutQuery as SourceCheckoutQuery } from 'SourceQuery/Checkout.query';

/** @namespace Satisfly/Query/Checkout/Query */
export class CheckoutQuery extends SourceCheckoutQuery {
    _getOrderField() {
        return new Field('order')
            .addFieldList([
                new Field('order_id'),
                new Field('payu_redirect_url'),
            ]);
    }

    getPlaceOrderMutation(cartId, orderComment = '') {
        const mutation = new Mutation('placeOrder')
            .addArgument('input', 'PlaceOrderInput', { cart_id: cartId, order_comment: orderComment })
            .addField(this._getOrderField());

        return mutation;
    }

    setDocumentType(cart_id, document_type) {
        const mutation = new Mutation('setDocumentType')
            .addArgument('cart_id', 'String', cart_id)
            .addArgument('document_type', 'Int!', document_type)
            .addField('id')
            .addField('name');

        return mutation;
    }

    getAvailableDocumentTypesQuery() {
        return new Field('getAvailableDocumentTypes')
            .setAlias('documentTypes')
            .addField('id')
            .addField('name');
    }
}

export default new CheckoutQuery();
